import { endpointFactory } from '$/services/endpoints';
import { fetcher } from '$/services/fetcher';
import { filterGroupsToQuery } from '$/services/mapper/filter';
import { MaterialType } from '$/services/mapper/uses';
import { FilterGroup } from '$/services/usecases/filter';
import {
  MaterialsSchema,
  Materials,
  Material,
} from '$/services/usecases/materials/mapper/materials';

interface GetMaterialsPayload {
  ids?: string[];
  query?: string;
  limit?: number;
  filter?: FilterGroup[];
  signal?: AbortSignal;
  page?: number;
  type?: MaterialType[];
}

export type { Materials, Material };

export const getMaterials = async (
  payload: GetMaterialsPayload,
  useUniqueKeys: boolean = false,
): Promise<Materials> => {
  const { ids, query, signal, filter, limit = 50, page = 0, type } = payload;

  const [filterKeys, filterValues] = filterGroupsToQuery(filter);

  const idKey = useUniqueKeys ? 'unique_key' : 'id';

  const keys = [
    ids ? idKey : undefined,
    query ? 'info' : undefined,
    ids !== null ? filterKeys : undefined,
  ]
    .filter((i) => i)
    .join(';');

  const values = [
    ids?.join('|'),
    query,
    ids !== null ? filterValues : undefined,
  ]
    .filter((i) => i)
    .join(';');

  const hasCollectionFilter = filter?.some(({ type }) => type === 'collection');

  const url = endpointFactory.inspirationMaterial({
    searchValues: values,
    searchKeys: keys,
    sortOrder: hasCollectionFilter ? 'SEARCH_CRITERIA_INT_7' : 'id',
    limit,
    page,
    type,
    language: 'de',
  });

  return fetcher(url, {
    signal,
    msg: `could not fetch collections ${url}`,
    parser: (data) => MaterialsSchema.parse(data),
  });
};
